<template>
	<div class="manage-story">
		<Title title="管理故事內容"></Title>
		<div class="layout-row layout-hv-center top">
			<ProcessDetail :progress="editStoryData.progress" class="process"></ProcessDetail>
		</div>

		<div class="story-data col" align-x="center" gutter="20">
			<layout-gray>
				<el-collapse v-model="activeNames">
					<el-collapse-item :title="(!is18)?'* 1. 成立小組（由輔導員填寫）': '* 1. 成立小組（由代表人及綁定帳號者填寫）'" name="1">
						<team :editStoryData="editStoryData" v-if="!isEdit[0]" @edit="changeEditType(0)" @next="handleNext('1')" :is18="is18" />
						<TeamFormUnder18 :editStoryData="editStoryData" v-if="isEdit[0] && !is18" @browsMode="changeEditType(0)"></TeamFormUnder18>
						<TeamFormUpper18 :editStoryData="editStoryData" v-if="isEdit[0] && is18" @browsMode="changeEditType(0)"></TeamFormUpper18>
					</el-collapse-item>
					<el-collapse-item title="* 2.1 感受" name="2" id="el2">
						<Problem :editStoryData="editStoryData" v-if="!isEdit[1]" @edit="changeEditType(1)" @next="handleNext('2')" />
						<ProblemForm :editStoryData="editStoryData" v-else @browsMode="changeEditType(1)" />
					</el-collapse-item>
					<el-collapse-item title="* 2.2 以照片分享歷程：上傳 DFC 四步驟照片" name="3" id="el3">
						<pictures v-if="!isEdit[2]" @edit="changeEditType(2)" @next="handleNext('3')" />
						<pictures-form v-else @browsMode="changeEditType(2)" />
					</el-collapse-item>
					<el-collapse-item title="* 2.3 以文字分享歷程：上傳 DFC 四步驟學習單" name="4" id="el4">
						<Pdf v-if="!isEdit[3]" @edit="changeEditType(3)" @next="handleNext('4')"></Pdf>
						<PdfForm v-else @browsMode="changeEditType(3)"></PdfForm>
					</el-collapse-item>
					<el-collapse-item title="2.4 DFC 挑戰故事授權同意書" name="5" id="el5">
						<Auth v-if="!isEdit[4]" :is18="is18" @edit="changeEditType(4)" @next="handleNext('5')"></Auth>
						<AuthForm v-else :is18="is18" @browsMode="changeEditType(4)"></AuthForm>
					</el-collapse-item>
					<el-collapse-item title="2.5 上傳 DFC 挑戰故事影片" name="6" id="el6">
						<Video v-if="!isEdit[5]" @edit="changeEditType(5)" @next="handleNext('6')"></Video>
						<VideoForm v-else @browsMode="changeEditType(5)"></VideoForm>
					</el-collapse-item>
					<el-collapse-item title="2.6 SDGs" name="7" id="el7">
						<Sdgs v-if="!isEdit[6]" @edit="changeEditType(6)" @next="handleNext('7')"></Sdgs>
						<SdgsForm v-else @browsMode="changeEditType(6)"></SdgsForm>
					</el-collapse-item>
					<el-collapse-item title="* 3.1 填寫國際證書資料" name="8" id="el8">
						<Certificate v-if="!isEdit[7]" @edit="changeEditType(7)" :is18="is18" @next="handleNext('8')"></Certificate>
						<CertificateForm v-else :is18="is18" @browsMode="changeEditType(7)"></CertificateForm>
					</el-collapse-item>
					<el-collapse-item v-if="userInfo.role != 'visitor'" title="* 3.2 填寫輔導員問卷" name="9" @next="handleNext('9')" id="el9">
						<Questionnaire :is18="is18"></Questionnaire>
					</el-collapse-item>
				</el-collapse>
				<div class="submit col">
					<div class="el-collapse-item__header">3.3 報名參加分享季</div>
					<div class="el-collapse-item__content col" gutter="25">
						<p>我想讓我的故事被更多人看見：</p>
						<div class="col" align-x="center" gutter="40">
							<div class="col" gutter="5" style="width:80%">
								<el-popover trigger="hover" title="提示" placement="top">
									<i class="el-icon-info" style="color:red;">&nbsp;如欲參加分享季，請確認：
										<ol>
											<li><b>步驟 2.5「故事影片」</b>已上傳；</li>
											<li><b>步驟2.4「同意授權」</b>勾選<b>同意</b></li>
										</ol>
									</i>
									<el-tag class="center" slot="reference">
										<el-checkbox v-model="editStoryData.is_participate" :disabled="checkboxDisabled">我希望透過 DFC 臺灣的媒合，讓更多人看到我們解決問題的故事！</el-checkbox>
									</el-tag>
								</el-popover>
								<br>
								<span>*請務必完成填寫步驟 2.4 故事資料授權喔！
									<br>*勾選此選項，僅代表貴團隊有意願被 DFC 臺灣媒合，每年 DFC 臺灣媒合的管道與數量不同，如有合適的機會，我們將主動聯繫您。
									<br>*DFC 臺灣保有隨時修改及終止本活動之權利，若有更動，將依 DFC 臺灣官網網站公佈為準。</span>
							</div>
						</div>
						<div class="save-share-btn button-tp color-white bg-green1" @click="saveShareSeason">儲存</div>
					</div>
				</div>
			</layout-gray>
			<div class="row" gutter="20">
				<el-button type="info" class="btn back-btn button-tp color-white bg-text4" @click="backPost">
					回上一頁</el-button>
				<el-button type="danger" class="btn reject-btn button-tp color-white bg-danger" @click="reject">
					資料不完整</el-button>
				<el-button type="success" class="btn pass-btn button-tp color-white bg-green1" @click="pass">
					繳交完成</el-button>
			</div>
		</div>
		<el-dialog title="資料不完整" :visible.sync="rejectDialogShow" width="800px">
			<el-checkbox-group v-model="rejectSelect">
				<template v-for="option in rejectOptions">
					<el-checkbox :label="option" :key="option" />
				</template>
			</el-checkbox-group>
			<el-input class="reject-text" type="textarea" :autosize="{ minRows: 5}" placeholder="" v-model="rejectText" />
			<div class="reject-btn-box layout-row">
				<el-button type="danger" @click="rejectDialogShow = false">取 消</el-button>
				<el-button type="success" @click="rejectApply">送 出</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import LayoutGray from "@/components/challenge/signUp/LayoutGray.vue";
import ProcessDetail from "@/components/challenge/signUp/ProcessDetail";
import QuestionnaireStatus from "@/components/challenge/signUp/editStory/QuestionnaireStatus.vue";
import Title from "@/components/backendManage/Title";
import { mapActions, mapState } from "vuex";
import config from "@/data/config.json";
import rejectOptions from "@/data/rejectOptions.json";
import Joi from "joi";
import _ from "lodash";

import {
	Team,
	TeamFormUnder18,
	TeamFormUpper18,
	Problem,
	ProblemForm,
	Video,
	VideoForm,
	Auth,
	AuthForm,
	Certificate,
	CertificateForm,
	PicturesForm,
	Pictures,
	Pdf,
	PdfForm,
	Questionnaire
} from "@/components/challenge/signUp/editStory";

export default {
	data() {
		return {
			isEdit: [false, false, false, false, false, false, false],
			activeNames: ["1", "2", "3", "4", "5", "6", "7", "8"],
			shareSession: config.shareSession,
			rejectDialogShow: false,
			rejectOptions: rejectOptions,
			rejectSelect: [],
			rejectText: ""
		};
	},
	computed: {
		...mapState("story", ["editStoryData"]),
		...mapState("user", ["userInfo"]),
		checkboxDisabled() {
			let authVal = this.handleAuth();
			const { src } = this.editStoryData && this.editStoryData.video || new Object;
			const { agree_authorize } = this.editStoryData || new Object;

			if (authVal && src && agree_authorize) return false;
			else {
				this.editStoryData.is_participate = false;
				return true;
			}
		},
		is18() {
			return this.editStoryData.is_18;
		}
	},
	methods: {
		...mapActions("story", [
			"fetchEditStory",
			"getQuestionnaireStatus",
			"updateStory",
			"applyFailed",
			"applySuccess",
			"downloadStoryFiles"
		]),
		reject() {
			this.rejectDialogShow = true;
		},
		async pass() {
			let data = {
				id: this.editStoryData.id
			};
			try {
				await this.applySuccess(data);
				this.$message.success("審核通過，報名完成！");
			} catch (e) {
				this.$message.error(e.message);
			}
		},
		async rejectApply() {
			let data = {
				id: this.editStoryData.id,
				message: {
					failed_message: this.rejectText + "\n\n" + this.rejectSelect.join("\n")
				}
			};
			try {
				this.rejectDialogShow = false;
				await this.applyFailed(data);
				this.$message.success("設定完成");
			} catch (e) {
				this.$message.error(e.message);
			}
		},
		changeEditType(i) {
			this.$set(this.isEdit, i, !this.isEdit[i]);
		},
		handleNext(name) {
			if (_.indexOf(this.activeNames, name) != -1) {
				_.remove(this.activeNames, activeName => {
					return activeName == name;
				});
			} else {
				this.activeNames.push(name);
			}
			this.activeNames = _.cloneDeep(this.activeNames);
		},
		validator(data, schema) {
			const { error } = Joi.validate(data, schema, {
				allowUnknown: true
			});
			if (error) return false;
			return true;
		},
		handleAuth() {
			let data = this.editStoryData;

			let authTeamMambersVal = this.validator(
				data.team_members,
				Joi.array()
					.min(1)
					.required()
			);
			let authCounselorsVal = this.validator(
				data.counselors,
				Joi.array()
					.min(1)
					.required()
			);
			if (authTeamMambersVal && authCounselorsVal) {
				return true;
			} else {
				return false;
			}
		},
		async saveShareSeason() {
			let data = {
				id: this.editStoryData.id,
				is_participate: this.editStoryData.is_participate
			};
			await this.updateStory(data);
			this.$message.success("儲存成功");
		},
		backPost() {
			window.history.go(-1);
		},
		async init() {
			this.storyId = this.$route.params.id;
			await this.getStoryData();
		},
		async getStoryData() {
			try {
				await this.fetchEditStory(this.storyId);
				await this.getQuestionnaireStatus();
				if (this.$route.query.is18 == undefined) {
					this.$router.replace({ query: { is18: this.editStoryData.is_18 } });
				}
			} catch (e) {
				this.$message.error(e);
			}
		},
	},
	created() { },
	mounted() {
		this.init();
	},
	components: {
		LayoutGray,
		Team,
		TeamFormUnder18,
		TeamFormUpper18,
		Problem,
		ProblemForm,
		Video,
		VideoForm,
		Auth,
		AuthForm,
		Certificate,
		CertificateForm,
		PicturesForm,
		Pictures,
		Pdf,
		PdfForm,
		Questionnaire,
		QuestionnaireStatus,
		ProcessDetail,
		Title,
		Sdgs: () => import("@/components/challenge/signUp/editStory/SDGs"),
		SdgsForm: () => import("@/components/challenge/signUp/editStory/SDGsForm")
	}
};
</script>

<style lang="scss" scoped>
.el-checkbox {
	display: flex;
	white-space: pre-wrap;
	align-items: baseline;
	margin-bottom: 10px;
}
</style>

<style lang="scss">
.manage-story {
	max-width: 900px;

	.top {
		margin: 40px 0;
		.process {
			width: 900px;
		}
	}

	.story-data {
		.disableApply {
			background-color: #909399;
			cursor: not-allowed;
		}

		.el-collapse-item__header {
			background-color: #ececec !important;
			padding-left: 10px;
		}
		.el-collapse-item__content {
			background-color: #f6f7f8 !important;
			padding: 20px;
		}
		.el-collapse-item__arrow {
			line-height: 48px !important;
		}

		.submit-story-button {
			width: 380px;
			height: 52px;
		}
	}

	.btn-box {
		margin: 20px 0 40px 0;

		.btn {
			width: 220px;
			height: 45px;
		}

		.reject-btn {
			margin: 0 70px;
		}
	}

	.reject-select {
		.el-select {
			width: 75%;
			margin-right: 20px;
		}
	}

	.reject-text {
		margin: 20px 0 30px 0;
	}

	.reject-btn-box {
		justify-content: flex-end;
	}

	.save-share-btn {
		width: 149px;
		height: 30px;
		align-self: flex-end;
	}
}
</style>